import { contact } from "@kanata/shared";

const KEY = "kanata:pasang-notice-dismissed";

/**
 * Whether the customer ticked "Jangan tampilkan ini lagi" on the pasang notice.
 *
 * Kept in this browser only: it is a convenience, not a record. Storage can be
 * blocked or wiped (private windows, cleared site data), and then the notice
 * simply shows again — the safe direction for something about booking a
 * technician.
 */
export function pasangNoticeDismissed(storage: Pick<Storage, "getItem"> | undefined = globalStorage()): boolean {
  try {
    return storage?.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissPasangNotice(storage: Pick<Storage, "setItem"> | undefined = globalStorage()): void {
  try {
    storage?.setItem(KEY, "1");
  } catch {
    // Nowhere to remember it; the notice shows next time.
  }
}

function globalStorage(): Storage | undefined {
  try {
    return typeof window === "undefined" ? undefined : window.localStorage;
  } catch {
    return undefined;
  }
}

/** A WhatsApp link that opens already asking about a technician. */
export function pasangWhatsappUrl(productNames: string[] = []): string {
  const what = productNames.length > 0 ? ` untuk ${productNames.join(", ")}` : "";
  const text = `Halo Kanata, saya mau tanya ketersediaan teknisi untuk pemasangan di tempat${what}.`;
  return `https://wa.me/${contact.whatsappDigits}?text=${encodeURIComponent(text)}`;
}
